import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';

import PriceBoostItemImpl from './price-boost-item.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A component designed to visualize a selection with a boosted price.
 *
 * @class PriceBoostItem
 * @memberof Mojito.Modules
 */

/**
 * `PriceBoostItem` prop types.
 *
 * @property {object} event - The parent event associated with the market(s).
 * @property {object} market - Related market object.
 * @property {object} selection - The specific selection to be displayed.
 *
 * @memberof Mojito.Modules.PriceBoostItem
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    selection: PropTypes.object.isRequired,
};

export default UIView('PriceBoostItem', PriceBoostItemImpl, propTypes);
